import PropTypes from 'prop-types';

import { Viewport } from 'constants/responsive';

import { srcOrNextImageProp } from './imageProps';

export const ResponsiveImageProps = PropTypes.shape({
  [Viewport.MOBILE]: srcOrNextImageProp.isRequired,
  [Viewport.TABLET]: srcOrNextImageProp.isRequired,
  [Viewport.DESKTOP]: srcOrNextImageProp.isRequired,
});
